const LOG_TAG = '[contact_upgrade_lx_info]';
const CONTACT_COUNT_LIMIT = 20000;
export const upgradeLxInfo = async (trans) => {
    var _a, _b, _c;
    console.warn(`${LOG_TAG} 迁移开始`);
    let totalCount = 0;
    let successCount = 0;
    let skipCount = 0;
    let errorCount = 0;
    try {
        const allContacts = await trans.table('contact').toArray();
        const validContacts = allContacts.filter(c => c.visibleCode === 0 && c.accountStatus !== 3);
        totalCount = validContacts.length;
        if (totalCount >= CONTACT_COUNT_LIMIT) {
            console.warn(`${LOG_TAG} 跳过迁移：联系人数量 ${totalCount} >= ${CONTACT_COUNT_LIMIT}`);
            return;
        }
        const yunxinItems = await trans.table('contactItem').where('contactItemType').equals('yunxin').toArray();
        const yunxinMap = new Map();
        for (const item of yunxinItems) {
            const existing = yunxinMap.get(item.contactId);
            if (!existing || ((_a = item._lastUpdateTime) !== null && _a !== void 0 ? _a : 0) > ((_b = existing._lastUpdateTime) !== null && _b !== void 0 ? _b : 0)) {
                yunxinMap.set(item.contactId, item);
            }
        }
        const lxInfoRows = [];
        for (const contact of validContacts) {
            const yunxinItem = yunxinMap.get(contact.id);
            if (!yunxinItem) {
                skipCount++;
                continue;
            }
            lxInfoRows.push({
                contactId: contact.id,
                avatar: contact.avatar,
                yxid: yunxinItem.contactItemVal,
                yxToken: yunxinItem.contactItemRefer,
            });
        }
        try {
            await trans.table('lx_info').bulkPut(lxInfoRows);
            successCount = lxInfoRows.length;
        }
        catch (bulkErr) {
            const successIds = ((_c = bulkErr) === null || _c === void 0 ? void 0 : _c.failures) ? lxInfoRows.length - Object.keys(bulkErr.failures).length : 0;
            successCount = successIds;
            errorCount = lxInfoRows.length - successIds;
            console.error(`${LOG_TAG} 批量写入部分失败`, bulkErr);
        }
    }
    catch (err) {
        errorCount++;
        console.error(`${LOG_TAG} 迁移异常`, err);
    }
    console.warn(`${LOG_TAG} 迁移完成 | 总数: ${totalCount} | 成功: ${successCount} | 跳过(无yunxin): ${skipCount} | 异常: ${errorCount}`);
};
